import { createContext } from "react";

const airContext = createContext({
  airItems: [false],
  setAirItems: (items) => {}
});

export default airContext;
